<ul class="menu-container">
  @for(item of items; track $index) {
  <li id="simpleMenuItem"
      (click)="selectItem(item)"
      (keyup.enter)="onKeyPress(item)"
      [class.selected]="item === itemSelected"
      tabindex="0">
    {{ item }}
  </li>
  }
</ul>
